
const ensureTrailingSlash = path => {
    return path[path.length] === "/" ? path : `${path}/`;
}

export const eventUrl = (ev) => {
    return ensureTrailingSlash(`eventers/${ev.slug}`);
};

export const pageAttachmentUrl = (page, mediaItem) => {
    return ensureTrailingSlash(`${page.uri}${mediaItem.slug}`);
};

export const blogAttachmentUrl = (post, mediaItem) => {
    return ensureTrailingSlash(`${blogUrl(post)}${mediaItem.slug}`);
};

export const blogUrl = (post) => {
    return ensureTrailingSlash(post.uri.indexOf("blog") < 3 ? post.uri : `blog/${post.uri}`);
};

export const postUrl = (post) => {
    return ensureTrailingSlash(`/news/blog/${post.slug.raw}`);
};
